export default __webpack_public_path__ + "static/media/problem_solv_inactive.49a3a89b.svg";